import EditIcon from "@material-ui/icons/Edit";
import { CheckCircle, Translate } from "@material-ui/icons";
// eslint-disable-next-line import/no-unresolved
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { SvgIconTypeMap } from "@material-ui/core";
import { IFile } from "@evennt-tech/api-v2-core";

export enum LocalizationLanguageConfigurationStep {
  Language = 0,
  LocalMap = 1,
  ProductCategory = 2,
  ProductColors = 3,
  Publish = 4,
}

export const LocalizationLanguageConfigurationSectionName = {
  [LocalizationLanguageConfigurationStep.LocalMap]: "localMap",
  [LocalizationLanguageConfigurationStep.ProductCategory]: "productCategories",
  [LocalizationLanguageConfigurationStep.ProductColors]: "productColors",
} as const;

export const LOCALIZATION_LANGUAGE_SECTION_TITLE_BY_STEP: Record<
  LocalizationLanguageConfigurationStep,
  string
> = {
  [LocalizationLanguageConfigurationStep.Language]: "Languages",
  [LocalizationLanguageConfigurationStep.LocalMap]:
    "Translation for Local Map Settings",
  [LocalizationLanguageConfigurationStep.ProductCategory]:
    "Translation for Product Categories",
  [LocalizationLanguageConfigurationStep.ProductColors]:
    "Translation for Colours",
  [LocalizationLanguageConfigurationStep.Publish]: "Language Details",
};

export const LOCALIZATION_LANGUAGE_STEP_TITLE_MAP: Record<
  LocalizationLanguageConfigurationStep,
  string
> = {
  [LocalizationLanguageConfigurationStep.Language]: "Select Language",
  [LocalizationLanguageConfigurationStep.LocalMap]: "Local Map Settings",
  [LocalizationLanguageConfigurationStep.ProductCategory]: "Product Categories",
  [LocalizationLanguageConfigurationStep.ProductColors]: "Colours",
  [LocalizationLanguageConfigurationStep.Publish]: "Publish",
};

export const LOCALIZATION_LANGUAGE_STEP_ICON_MAP: Record<
  LocalizationLanguageConfigurationStep,
  OverridableComponent<SvgIconTypeMap>
> = {
  [LocalizationLanguageConfigurationStep.Language]: EditIcon,
  [LocalizationLanguageConfigurationStep.LocalMap]: Translate,
  [LocalizationLanguageConfigurationStep.ProductCategory]: Translate,
  [LocalizationLanguageConfigurationStep.ProductColors]: Translate,
  [LocalizationLanguageConfigurationStep.Publish]: CheckCircle,
};

export const DEFAULT_LANGUAGE_NAME = "English (UK)";

export type LocalizationLanguageConfigurationSectionNames = typeof LocalizationLanguageConfigurationSectionName[keyof typeof LocalizationLanguageConfigurationSectionName];

export type LocalizationLanguageFormNestedKeyItem = Record<
  string,
  Record<string, string>
>;
export type LocalizationLanguageConfigurationFormReturn = {
  productImagePlaceholder: IFile | { file: File } | null;
  isPublishEnabled: boolean;
} & {
  [K in LocalizationLanguageConfigurationSectionNames]: LocalizationLanguageFormNestedKeyItem;
};

// prettier-ignore
export type LocalizationLanguageFormNestedKey = `${string}.${string}`;

export const SOME_TOLGEE_TRANSLATIONS_NOT_APPROVED_ERROR =
  "SOME_TOLGEE_TRANSLATIONS_NOT_APPROVED";

export const ICU_INFO_URL =
  "https://docs.tolgee.io/platform/translation_process/icu_message_format";
